import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';

import { logout, logoutSuccess } from '../../reducers/auth';

import api from '../../lib/api';

class Logout extends Component {
  static propTypes = {
    logout: PropTypes.func,
    logoutSuccess: PropTypes.func
  };

  state = {
    logoutFail: false
  };

  onLogout = async () => {
    try {
      this.props.logout();

      await api.logout();

      this.props.logoutSuccess();
    } catch (ex) {
      console.log('ex', ex);
      console.log('ex', ex.response.data);

      this.setState({
        logoutFail: `${ex.response.data.status || 500}: ${ex.response.data
          .message || 'Server Error'}`
      });
    }
  };

  onSnackbarClose = () => {
    this.setState({ logoutFail: false });
  };

  render() {
    const { logoutFail } = this.state;

    return (
      <div>
        <IconButton onClick={this.onLogout}>
          <ExitToAppIcon />
        </IconButton>

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          open={!!logoutFail}
          autoHideDuration={6000}
          onClose={this.onSnackbarClose}
          message={logoutFail}
          action={[
            <IconButton key={0} onClick={this.onSnackbarClose}>
              <CloseIcon nativeColor="#fff" />
            </IconButton>
          ]}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  logout: (...params) => dispatch(logout(...params)),
  logoutSuccess: (...params) => dispatch(logoutSuccess(...params))
});

export default connect(null, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/organisms/Logout/index.js